import Typography from '@ixigo/iui/Typography';
import cn from '@repo/shared/utils/cn';
import { formatPrice } from '@repo/shared/utils/priceFormatter';
import type { CabPricing, VehicleType } from '@/api';
export interface SummaryProps {
	vehicleType: VehicleType;
	model: string;
	pricing: CabPricing;

	/**
	 * Whether burn is opted for the cab
	 * @default true
	 */
	burnOpted?: boolean;
}

// TODO: it should not take the complete pricing object,
// if it takes it should also consider whether burn is applied or not
// and use displayPrice or displayPriceWithoutBurn
export const Summary = ({
	vehicleType,
	model,
	pricing,
	burnOpted = true,
}: SummaryProps) => {
	const { displayPrice, strikePrice, displayPriceWithoutBurn } = pricing;

	const fare = burnOpted ? displayPrice : displayPriceWithoutBurn;

	return (
		<div className="flex items-start justify-between">
			<div className="flex flex-col items-start gap-y-1">
				<Typography variant="body-md" fontWeight="medium" className="text-left">
					{vehicleType}
				</Typography>
				<Typography variant="body-xs" className="text-left">
					{model}
				</Typography>
			</div>
			<div className="flex items-baseline">
				{strikePrice && fare !== strikePrice ? (
					<Typography
						variant="body-xs"
						className={cn(
							'text-critical line-through decoration-current inline-block align-baseline pr-0.5',
						)}
					>
						<span className="text-secondary">{formatPrice(strikePrice)}</span>
					</Typography>
				) : null}
				<Typography
					variant="body-md"
					fontWeight="medium"
					className="inline-block align-middle"
				>
					{formatPrice(fare)}
				</Typography>
			</div>
		</div>
	);
};
